export default {
  'inverter': [{
    text: 'Block',
    key: 'block_id'
  }, {
    text: 'Room',
    key: 'inverter_room'
  }, {
    text: 'Inverter',
    key: 'inverter_id'
  }],
  'weather station': [{
    text: 'Block',
    key: 'block_id'
  }, {
    text: 'Weather Station',
    key: 'ws_id'
  }],
  'scb': [{
    text: 'Block',
    key: 'block_id'
  }, {
    text: 'Room',
    key: 'inverter_room'
  }, {
    text: 'Inverter',
    key: 'inverter_id'
  }, {
    text: 'SCB',
    key: 'scb_id'
  }],
  'mppt': [{
    text: 'Block',
    key: 'block_id'
  }, {
    text: 'Room',
    key: 'inverter_room'
  }, {
    text: 'Inverter',
    key: 'inverter_id'
  }],
  'mfm': [{
    text: 'Block',
    key: 'block_id'
  }, {
    text: 'MFM',
    key: 'feeder_id'
  }],
  'ups': [{
    text: 'UPS',
    key: 'ups_id'
  }],
  'transformer': [{
    text: 'Block',
    key: 'block_id'
  }, {
    text: 'Room',
    key: 'inverter_room'
  }, {
    text: 'Transformer',
    key: 'transformer_id'
  }],
  'energy meter': [{
    text: 'Block',
    key: 'block_id'
  }, {
    text: 'Energy Meter',
    key: 'em_id'
  }],
  'soil sensor': [{
    text: 'Block',
    key: 'block_id'
  }, {
    text: 'Soil Sensor',
    key: 'soil_sensor_id'
  }],
  'annunciator': [{
    text: 'Device',
    key: 'device_id'
  }],
  'relay': [{
    text: 'Block',
    key: 'block_id'
  }, {
    text: 'Relay',
    key: 'relay_id'
  }],
  'breaker': [{
    text: 'Block',
    key: 'block_id'
  }, {
    text: 'Breaker',
    key: 'breaker_id'
  }],
  grid: [{
    text: 'Grid',
    key: 'id'
  }]
}
